import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Header from '~/components/shared/Header/Header';
import TrustpilotWidget from '~/components/shared/TrustpilotWidget/TrustpilotWidget';
import { StepStatus } from '~/enums';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import useMarketConfig from '~/hooks/useMarketConfig';
import { RootState } from '~/store';
import { pushToGtmLoanAction } from '~/store/actions/gtmActions';
import {
  LaunchViewTopWrapper,
  TrustPilotWidgetContainer,
} from './LaunchView.styled';
import ApplicationDescriptionSection from './components/ApplicationDescriptionSection/ApplicationDescriptionSection';
import CustomerReviewsSection from './components/CustomerReviewsSection/CustomerReviewsSection';
import HelpSection from './components/HelpSection/HelpSection';
import LaunchViewForm from './components/LaunchViewForm/LaunchViewForm';
import { LaunchViewContainer } from './components/LaunchViewForm/LaunchViewForm.styled';
import Slideshow from './components/Slideshow/Slideshow';

const LaunchView = () => {
  const dispatch = useAppDispatch();

  const { matchedMedia } = useSelector((state: RootState) => state);
  const { marketHasTrustpilot } = useMarketConfig();

  useEffect(() => {
    dispatch(
      pushToGtmLoanAction({
        stepStatus: StepStatus.Started,
      })
    );
  }, [dispatch]);

  return (
    <LaunchViewContainer>
      <Header />
      <LaunchViewTopWrapper>
        <Slideshow />
        {!matchedMedia.desktop && marketHasTrustpilot && (
          <TrustPilotWidgetContainer>
            <TrustpilotWidget />
          </TrustPilotWidgetContainer>
        )}
        <LaunchViewForm />
      </LaunchViewTopWrapper>
      {matchedMedia.desktop && marketHasTrustpilot && (
        <TrustPilotWidgetContainer>
          <TrustpilotWidget />
        </TrustPilotWidgetContainer>
      )}
      <ApplicationDescriptionSection />
      <CustomerReviewsSection />
      <HelpSection />
    </LaunchViewContainer>
  );
};

export default LaunchView;
